import { observer } from 'mobx-react-lite'
import Styles from './CreditUsageDropdown.module.scss'

import { PaymentPlanKey } from 'api/clients/PaymentPlanClient'
import { useRootStore } from 'stores/RootStore'
import { Button } from 'blaze-ui/Button'
import { useModals } from 'almanac-ui/Modal'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import { Credits } from 'blaze-ui/icons/20/Credits'
import { CreditsBalanceModal } from './components/CreditsBalanceModal/CreditsBalanceModal'
import { useCreditUsage } from 'hooks/useCreditUsage'
import { AlertTriangle } from 'blaze-ui/icons'
import { CreditsLowWarning } from './components/CreditsLowWarning'

interface Props {
  showCreditsWarning?: boolean
}

export const CreditUsageDropdown = observer(({ showCreditsWarning = true }: Props) => {
  const workspace = useCurrentWorkspace()
  const { openModal } = useModals()
  const {
    tierUsageStore: { currentSubscription },
  } = useRootStore()
  const isTrialing = currentSubscription?.status === 'trialing'
  const isOnPioneer = currentSubscription?.plan === PaymentPlanKey.VirtualMarketer
  const isOnPioneerTrial = isTrialing && isOnPioneer
  const { creditsRemaining, isOutOfCredits } = useCreditUsage()

  if (
    !workspace?.is_virtual_marketer ||
    workspace.is_ap_freemium ||
    isOnPioneerTrial ||
    !currentSubscription ||
    currentSubscription?.status === 'canceled'
  ) {
    return null
  }

  const openCreditsBalanceModal = () => {
    openModal(CreditsBalanceModal)
  }

  if (currentSubscription?.status === 'trialing') return null

  return (
    <div className={Styles.creditsContainer}>
      {showCreditsWarning && <CreditsLowWarning />}
      <Button
        color={isOutOfCredits ? 'var(--out-of-credits)' : undefined}
        frontIcon={isOutOfCredits ? AlertTriangle : Credits}
        variant="tertiary"
        className={Styles.button}
        onPress={openCreditsBalanceModal}
      >
        {`${creditsRemaining} Credits`}
      </Button>
    </div>
  )
})
